import { render, staticRenderFns } from "./mainFormDocumentMaintenance.vue?vue&type=template&id=dfff4c4e&"
import script from "./mainFormDocumentMaintenance.vue?vue&type=script&lang=js&"
export * from "./mainFormDocumentMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./mainFormDocumentMaintenance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports